import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/instragram.gif'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = { id: "ap-wrapper" }
const _hoisted_3 = { id: "ap-canvas" }
const _hoisted_4 = { id: "ap-top-bar" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { id: "ap-welcome-text" }
const _hoisted_7 = {
  key: 1,
  href: "https://membranesolutions.com/contact"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = { id: "ap-flex" }
const _hoisted_11 = { id: "ap-side-menu" }
const _hoisted_12 = { id: "ap-menu-bar" }
const _hoisted_13 = { id: "ap-menu-content" }
const _hoisted_14 = { id: "ap-site-content" }
const _hoisted_15 = { id: "ap-footer" }
const _hoisted_16 = { id: "ap-footer-links" }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "ap-branding-text" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "ap-branding-text" }
const _hoisted_25 = { href: "https://www.instagram.com/airproductsmiddleeast/" }
const _hoisted_26 = { href: "https://www.instagram.com/carburos_metalicos" }
const _hoisted_27 = ["href"]
const _hoisted_28 = { class: "ap-branding-text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ap_link = _resolveComponent("ap-link")
  const _component_left_nav = _resolveComponent("left-nav")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { id: "ap-burger" }, [
            _createElementVNode("button", { type: "button" })
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('ml_107448', { displayName: $options.user.displayName })), 1),
            _cache[1] || (_cache[1] = _createElementVNode("a", { href: "https://my.airproducts.com" }, [
              _createElementVNode("span", { class: "ap-blue" }, "My"),
              _createElementVNode("span", { class: "ap-my-company" }, "AirProducts"),
              _createElementVNode("span", { class: "ap-service-mark" }, "℠")
            ], -1)),
            ($options.user.internal)
              ? (_openBlock(), _createBlock(_component_ap_link, {
                  key: 0,
                  href: "https://apdirect.airproducts.com"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("APDirect")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($options.isMembraneCustomer)
              ? (_openBlock(), _createElementBlock("a", _hoisted_7, _toDisplayString(_ctx.$t('ml_107453')), 1))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("a", {
              id: "osvc_reg_contactus",
              href: $data.contactUsUrl
            }, _toDisplayString(_ctx.$t('ml_107453')), 9, _hoisted_8), [
              [_vShow, !$options.isMembraneCustomer]
            ]),
            _withDirectives(_createElementVNode("a", {
              id: "osvc_reg_customerSupport",
              href: $data.customerSupportUrl
            }, _toDisplayString(_ctx.$t('ml_107454')), 9, _hoisted_9), [
              [_vShow, !$options.isMembraneCustomer]
            ])
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "right" }, [
            _createElementVNode("a", {
              href: "https://www.airproducts.com",
              id: "ap-my-company-website"
            }, "airproducts.com")
          ], -1))
        ]),
        _cache[14] || (_cache[14] = _createStaticVNode("<div id=\"ap-mega-menu\"><div id=\"ap-logo\"><a href=\"https://www.airproducts.com\"><img src=\"https://inc.airproducts.com/template/img/ap_logo.png\" alt=\"AirProducts Home\" width=\"206\" height=\"42\"></a></div><div id=\"my-ap\"><span class=\"ap-blue\">My</span><span class=\"ap-green ap-my-company\">AirProducts</span><span class=\"ap-green ap-service-mark\">℠</span></div></div>", 1)),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString($options.user.lastName) + ", " + _toDisplayString($options.user.firstName), 1),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_left_nav, {
                revalStatus: $options.revalidationStatus,
                items: $data.navItems
              }, null, 8, ["revalStatus", "items"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_router_view)
          ])
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("div", { id: "osvc_inlay" }, null, -1)),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("a", { href: $data.facebookUrl }, _cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "ap-branding-icon ap-facebook" }, null, -1),
              _createElementVNode("div", { class: "ap-branding-text" }, "Facebook", -1)
            ]), 8, _hoisted_17), [
              [_vShow, $options.user.countryCode != 'NL' &&
              $options.user.countryCode != 'BE' &&
              $options.user.countryCode != 'FR' &&
              $options.user.countryCode != 'NL' &&
              $options.user.countryCode != 'ES' &&
              $options.user.countryCode != 'PT' &&
              $options.user.countryCode != 'AR'
              ]
            ]),
            _withDirectives(_createElementVNode("a", { href: $data.twitterUrl }, _cache[5] || (_cache[5] = [
              _createElementVNode("div", { class: "ap-branding-icon ap-twitter" }, null, -1),
              _createElementVNode("div", { class: "ap-branding-text" }, "Twitter", -1)
            ]), 8, _hoisted_18), [
              [_vShow, $options.user.countryCode != 'NL' &&
              $options.user.countryCode != 'BE' &&
              $options.user.countryCode != 'FR' &&
              $options.user.countryCode != 'AR' &&
              $options.user.countryCode != 'BR' &&
              $options.user.countryCode != 'CO'
              ]
            ]),
            _withDirectives(_createElementVNode("a", { href: $data.youtubeUrl }, _cache[6] || (_cache[6] = [
              _createElementVNode("div", { class: "ap-branding-icon ap-youtube" }, null, -1),
              _createElementVNode("div", { class: "ap-branding-text" }, "Youtube", -1)
            ]), 8, _hoisted_19), [
              [_vShow, $options.user.countryCode != 'EC']
            ]),
            _withDirectives(_createElementVNode("a", { href: $data.linkedinUrl }, _cache[7] || (_cache[7] = [
              _createElementVNode("div", { class: "ap-branding-icon ap-linkedin" }, null, -1),
              _createElementVNode("div", { class: "ap-branding-text" }, "LinkedIn", -1)
            ]), 8, _hoisted_20), [
              [_vShow, $options.user.countryCode != 'PT']
            ]),
            _createElementVNode("a", { href: $data.legalnoticeUrl }, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "ap-branding-icon ap-legalnotice" }, null, -1)),
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('ml_113152')), 1)
            ], 8, _hoisted_21),
            _createElementVNode("a", { href: $data.privacypolicyUrl }, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "ap-branding-icon ap-legalnotice" }, null, -1)),
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('ml_113151')), 1)
            ], 8, _hoisted_23),
            _withDirectives(_createElementVNode("a", _hoisted_25, _cache[10] || (_cache[10] = [
              _createElementVNode("div", { class: "ap-branding-icon" }, [
                _createElementVNode("img", { src: _imports_0 })
              ], -1),
              _createElementVNode("div", { class: "ap-branding-text" }, "Instagram", -1)
            ]), 512), [
              [_vShow, $options.user.countryCode == 'AE' || $options.user.countryCode == 'OM']
            ]),
            _withDirectives(_createElementVNode("a", _hoisted_26, _cache[11] || (_cache[11] = [
              _createElementVNode("div", { class: "ap-branding-icon" }, [
                _createElementVNode("img", { src: _imports_0 })
              ], -1),
              _createElementVNode("div", { class: "ap-branding-text" }, "Instagram", -1)
            ]), 512), [
              [_vShow, $options.user.countryCode == 'ES']
            ]),
            _createElementVNode("a", { href: $data.cookieNoticeUrl }, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "ap-branding-icon ap-legalnotice" }, null, -1)),
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('ml_144167')), 1)
            ], 8, _hoisted_27)
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("div", { id: "ap-copyright" }, "Copyright © 1996 – 2018 Air Products and Chemicals, Inc", -1))
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("div", { id: "ap-menu-overlay" }, null, -1))
      ])
    ]),
    _cache[17] || (_cache[17] = _createElementVNode("div", { id: "ap-loading-overlay" }, [
      _createElementVNode("div", { id: "ap-loading-image" })
    ], -1))
  ]))
}